export const SidebarContentData = [
    {
        img: 'sidebar-content-img',
        link: 'Overview',
    },

    {
        img: 'sidebar-content-img1',
        link: 'My Projects',
    },

    {
        img: 'sidebar-content-img2',
        link: 'Payment Methods',
    },

    {
        img: 'sidebar-content-img3',
        link: 'Showcase',
    },

    {
        img: 'sidebar-content-img4',
        link: 'Domains',
    },

    {
        img: 'sidebar-content-img5',
        link: 'Stores',
    },

    {
        img: 'sidebar-content-img6',
        link: 'Templates',
    },

    {
        img: 'sidebar-content-img7',
        link: 'Pricing',
    },

    {
        img: 'sidebar-content-img8',
        link: 'Account',
    },

    {
        img: 'sidebar-content-img9',
        link: 'Settings',
    }
]

export const TeamsData = [
    {
        img: 'teams-img1',
        title: 'Support Team',
        desc: '3 Members'
    },

    {
        img: 'teams-img2',
        title: 'Business Team',
        desc: '5 Members'
    },

    {
        img: 'teams-img3',
        title: 'Design Team',
        desc: '10 Members'
    }
]

export const PremiumData = [
    {
        img: 'premium-content-img1',
        desc: 'Remove Website Banner Ad'
    },
    {
        img: 'premium-content-img2',
        desc: 'Connect a Custom Domain'
    },
    {
        img: 'premium-content-img3',
        desc: 'Advanced Statistics'
    },
]